export default "__VITE_PUBLIC_ASSET__80529900__"